import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { ExpertiseRoutingModule } from './expertise-routing.module';
import { ExpertiseComponent } from './expertise/expertise.component';
import { MatCardModule } from '@angular/material/card';
import { MatTabsModule } from '@angular/material/tabs';
import { MatIconModule } from '@angular/material/icon';
import { MatButtonModule } from '@angular/material/button';
import { MatInputModule } from '@angular/material/input';
import { MatSelectModule } from '@angular/material/select';
import { DropdownModule } from 'primeng/dropdown';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { ExpertiseListComponent } from './expertise-list/expertise-list.component';
import { TableModule } from 'primeng/table';
import { ExpertiseViewComponent } from './expertise-view/expertise-view.component';
import { ExpertiseTabComponent } from './expertise-tab/expertise-tab.component';
import { ExpertisePanelComponent } from './expertise-panel/expertise-panel.component';
import { ExpertiseEditComponent } from './expertise-edit/expertise-edit.component';
import { ToastModule } from 'primeng/toast';
import { ComponentsModule } from '../components/components.module';
import { MentionModule } from 'angular2-mentions/mention';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatNativeDateModule } from '@angular/material';
import { ExpertiseTarifViewComponent } from './expertise-tarif-view/expertise-tarif-view.component';
import { Nl2BrPipeModule } from 'nl2br-pipe';
import { ExpertiseTarifEditComponent } from './expertise-tarif-edit/expertise-tarif-edit.component';
import { ExpertisePrestationsComponent } from './expertise-prestations/expertise-prestations.component';
import { CalendarModule } from 'primeng/calendar';
import { InputTextModule } from 'primeng/inputtext';
import { ExpertiseComptabiliteComponent } from './expertise-comptabilite/expertise-comptabilite.component';
import { MatMenuModule } from '@angular/material/menu';
import { MatListModule } from '@angular/material/list';
import { ToolbarModule } from 'primeng/toolbar';
import { ButtonModule } from 'primeng/button';
import { PanelModule } from 'primeng/panel';
import { CardModule } from 'primeng/card';
import { ExpertiseNotesComponent } from './expertise-notes/expertise-notes.component';
import { ExpertiseNoteComponent } from './expertise-note/expertise-note.component';
import { ExpertiseAddNoteComponent } from './expertise-add-note/expertise-add-note.component';
import { InputTextareaModule } from 'primeng/inputtextarea';
import { EditorModule } from 'primeng/editor';
import { CheckboxModule } from 'primeng/checkbox';
import { InputSwitchModule } from 'primeng/inputswitch';
import { DialogModule} from 'primeng/dialog';
import { NgxPermissionsModule } from 'ngx-permissions';
import { ConsignmentFormComponent } from './consignment-form/consignment-form.component';
import { DynamicDialogModule } from 'primeng/components/dynamicdialog/dynamicdialog';
@NgModule({
    declarations: [
        ExpertiseComponent,
        ExpertiseListComponent,
        ExpertiseViewComponent,
        ExpertiseTabComponent,
        ExpertisePanelComponent,
        ExpertiseEditComponent,
        ExpertiseTarifViewComponent,
        ExpertiseTarifEditComponent,
        ExpertisePrestationsComponent,
        ExpertiseComptabiliteComponent,
        ExpertiseNotesComponent,
        ExpertiseNoteComponent,
        ExpertiseAddNoteComponent,
        ConsignmentFormComponent
    ],
    entryComponents:  [
        ConsignmentFormComponent
    ],
    imports: [
        CommonModule,
        ExpertiseRoutingModule,
        MatCardModule,
        MatTabsModule,
        NgxPermissionsModule.forChild(),
        MatIconModule,
        MatButtonModule,
        MatInputModule,
        MatCheckboxModule    ,
        TableModule,
        ToastModule,
        FormsModule,
        ReactiveFormsModule,
        MentionModule,
        DynamicDialogModule,
	    DialogModule,
        ComponentsModule,
        MatDatepickerModule,
        MatNativeDateModule,
        Nl2BrPipeModule,
        MatSelectModule,
        DropdownModule,
        CalendarModule,
        InputTextModule,
        MatMenuModule,
        MatListModule,
        ToolbarModule,
        ButtonModule,
        PanelModule,
        CardModule,
        InputTextareaModule,
        EditorModule,
        CheckboxModule,
        InputSwitchModule
    ],
    exports: [
      	ExpertiseComponent
    ]
})
export class ExpertiseModule { }
